var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header__actions"},[_c('header-user-area'),_vm._v(" "),_c('a',{staticClass:"header__extra",attrs:{"href":"/account/wishlist"}},[_c('i',{staticClass:"icon-heart happi-icon gwishlist"}),_vm._v(" "),(_vm.wishlistTotal)?_c('span',{staticClass:"selected-number notifi-indicator pulsate"}):_vm._e()]),_vm._v(" "),_c('mini-cart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }